import { env, uploaded_file_url } from '../components/config';

export function generateReduxKeys(keys) {
  const localStorageKeys = Object.keys(localStorage);

  const initialState = {};

  const isValidJSON = (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  for (const key of Object.keys(keys)) {
    const generatedKey = key;
    const initialValue = keys[key];

    const keysList = localStorageKeys.filter((key) => key.endsWith(generatedKey));
    if (!keysList.includes(generatedKey)) initialState[generatedKey] = initialValue;

    keysList.forEach((key) => {
      const value = localStorage.getItem(key);

      if (value && isValidJSON(value)) {
        initialState[key] = JSON.parse(value);
      } else {
        initialState[key] = initialValue;
      }
    });
  }

  return initialState;
}

export const getInitials = (name) => {
  if (!name) return '';
  const nameParts = name.split(' ').filter((part) => part);
  const initials = nameParts
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

  return initials;
};

export const handleLogout = () => {
  localStorage.clear();
  window.location.href = '/';
};

export const getHighlightedText = (text, searchText) => {
  if (!searchText) return text;
  return text.split(new RegExp(`(${searchText})`, 'gi')).map((part, index) =>
    part.toLowerCase() === searchText ? (
      <mark key={index} style={{ backgroundColor: '#ffc069' }}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};

export const booleanToInteger = (value) => {
  return value ? 1 : 0;
};

export const integerToBoolean = (value) => {
  return value === 1;
};

export const getFileUrl = (path, id, fileName) => {
  return `${uploaded_file_url}/${env}/${path}/${id}/${fileName}`;
};
